<template>
    <div>
        <Banner :banners="banners" show-overlay class="green"> </Banner>
        <Breadcrumb></Breadcrumb>
        <div class="info-wrapper green">
            <h2 class="title text-center">數位多元導覽 帶你玩柳川</h2>
            <p class="text-sm">
                柳川是台中市中心重要河川之一，整治之後成為市區首座永續性生態工法開發的景觀河岸，白天景色宜人，晚上燈火璀璨，成為台中新興的熱門景點。在這個單元中，有多元的數位導覽方式可以遊覽柳川，快來一起玩耍吧!
            </p>
            <div class="row form-row mb-3">
                <div class="col-4">
                    <a
                        href=""
                        class="d-block"
                        @click.prevent="goView('/guide/attractions')"
                    >
                        <div class="guide-img-wrapper">
                            <img
                                src="@/assets/river_img_menu1.png"
                                style="width:50px;"
                                alt="列表導覽"
                            />
                            <div class="text">列表導覽</div>
                        </div>
                    </a>
                </div>
                <div class="col-4">
                    <a
                        href=""
                        class="d-block"
                        @click.prevent="$emit('show-map')"
                    >
                        <div class="guide-img-wrapper">
                            <img
                                src="@/assets/river_img_menu2.png"
                                style="width:50px;"
                                alt="地圖導覽"
                            />
                            <div class="text">地圖導覽</div>
                        </div>
                    </a>
                </div>
                <div class="col-4">
                    <a
                        href=""
                        class="d-block"
                        @click.prevent="goView('/guide/tour')"
                    >
                        <div class="guide-img-wrapper">
                            <img
                                src="@/assets/river_img_menu3.png"
                                style="width:50px;"
                                alt="分眾導覽"
                            />
                            <div class="text">分眾導覽</div>
                        </div>
                    </a>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-12">
                    <a href="./ar-guide" class="d-block">
                        <div class="guide-img-wrapper">
                            <div class="row form-row">
                                <div class="col-5">
                                    <img
                                        src="@/assets/river_img_menu4.png"
                                        alt="AR導覽與虛擬導遊"
                                    />
                                </div>
                                <div class="col-7">
                                    <div
                                        class="d-flex align-items-center h-100"
                                    >
                                        <div class="text">AR導覽與虛擬導遊</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
            <div class="row form-row">
                <div class="col-6">
                    <a
                        href=""
                        class="d-block"
                        @click.prevent="goView('/guide/customize')"
                    >
                        <div class="guide-img-wrapper">
                            <img
                                src="@/assets/river_img_menu5.png"
                                alt="自訂導覽"
                            />
                            <div class="text">自訂導覽</div>
                        </div>
                    </a>
                </div>
                <div class="col-6">
                    <a href="" class="d-block" @click.prevent="openQRCodeInMap">
                        <div class="guide-img-wrapper">
                            <img
                                src="@/assets/river_img_menu6.png"
                                alt="QR code導覽"
                            />
                            <div class="text">QR code導覽</div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable global-require */
import Banner from '@/components/shared/Banner';
import Breadcrumb from '@/components/Breadcrumb';
import coreMixin from '@/js/mixin/coreMixin';

export default {
    data() {
        return {
            banners: [
                {
                    linkUrl: require('@/assets/banner_guide.jpg'),
                },
            ],
        };
    },
    methods: {
        goView(link) {
            this.$router.push(link);
        },
        openQRCodeInMap() {
            this.$emit('show-map');
            this.toggleLayerVisible('qrcodesListLayer', true);
        },
    },
    components: {
        Banner,
        Breadcrumb,
    },
    mixins: [coreMixin],
    inject: ['toggleLayerVisible'],
};
</script>

<style></style>
